export const checkDeliveryDates = (dates) => {
  const { isFuture, differenceInDays } = require("date-fns");

  function isNotOver14DaysInFuture(date) {
    const currentDate = new Date();
    const futureLimit = currentDate.setDate(currentDate.getDate() + 14);
    return differenceInDays(date, futureLimit) <= 0;
  }

  return dates.every((date) => {
    const jsDate = new Date(date);
    return isFuture(jsDate) && isNotOver14DaysInFuture(jsDate);
  });
};
